export const ONE_DAY_IN_MS = 86400000;
export const ONE_DAY_IN_SECONDS = 86400;
export const ONE_DAY_IN_MINUTES = 1440;
export const HOURS_IN_A_DAY = 24;
export const DAYS_IN_A_WEEK = 7;